import config from "config";
export const adminRole = {
  superAdmin: 1,
  admin: 100,
};

export const CANCELLATION_TIME = 180;
export const LOGIN_COOKIE_NAME = "s_e_t";

export const PLUM_ROUTES = [
  "common",
  "product-list",
  "experiences",
  "vouchers",
  "profile",
  "checkout",
  "orders",
  "points",
  "xoxovouchers",
  "search",
  "payment-callback",
  "landing",
  "payment-exp-callback",
  "payment-status",
  "admin",
  "reset-password",
  "sso",
  "index.html",
  "insurance",
  "payment",
];

export const DATE_FORMAT = "DD MMMM YYYY";

export const defaultMaxQuantity = config.defaultMaxQuantity;

export const defaultMinQuantity = 1;

export const MOBILE_NO_ERROR =
  "Phone number should be between 7 to 16 digits only.";
export const currencyExchangeText =
  "Your wallet balance can change because of fluctuation in the currency exchange rates. You can view the change in wallet balance under Payments report.";
export const TURNSTILE_SITE_KEY = config.turnstileSiteKey;
